import { useEffect, useState } from "react";

const BASEURL = process.env.REACT_APP_BASE_URL;

const useVehicleDetails = ({ city, skip, limit }: { city: string; skip: number; limit: number }) => {
  const [vehicleList, setVehicleList] = useState<any[]>([]);
  const [cordinateList, setCordinateList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  // 🚚 Fetch Vehicle List
  useEffect(() => {
    let didCancel = false;
    setError(null);

    (async () => {
      try {
        setLoading(true);

        const response = await fetch(
          `${BASEURL}/v1/vehicle?city=${city}&skip=${skip}&limit=${limit}`,
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        const result = await response.json();
        const vehicleData = result?.data;

        if (!didCancel) setVehicleList(vehicleData || []);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();

    return () => {
      didCancel = true;
    };
  }, [city, skip, limit]);

  // 📍 Fetch Coordinates (Cluster OR TSP based on city)
  useEffect(() => {
    let didCancel = false;
    setError(null);

    (async () => {
      try {
        setLoading(true);

        const endpoint =
          city === "Ponda"
            ? `${BASEURL}/v1/insights/tsp-cordinate?city=${city}`
            : `${BASEURL}/v1/insights/cluster-cordinate?city=${city}`;

        const response = await fetch(endpoint, {
          headers: { "Content-Type": "application/json" },
        });

        const result = await response.json();

        const coordinates =
          city === "Ponda"
            ? result?.data?.tsp || []         // 🟢 Use tsp array for Ponda
            : result?.data?.clusters || [];   // 🔵 Use clusters for others

        if (!didCancel) setCordinateList(coordinates);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();

    return () => {
      didCancel = true;
    };
  }, [city]);

  return { vehicleList, cordinateList, loading, error };
};

export default useVehicleDetails;
